import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";

const Pagination = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "stretch",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {!props.hideResults && (
        <div style={{ color: "gray", padding: "20px 30px" }}>
          Showing {props.paginatedProperties.total} results.
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "20px 30px",
          width: props.hideResults ? "100%" : "",
        }}
      >
        <div
          style={{
            border: "1px solid #dddddd",
            padding: "5px",
            width: "20px",
            height: "20px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          className={`pagination_clickable${process.env.REACT_APP_TYPE}`}
          onClick={() => {
            props.handlePagination(1);
          }}
        >
          <FirstPageIcon style={{ color: "grey", fontSize: "20px" }} />
        </div>
        <div
          style={{
            border: "1px solid #dddddd",
            padding: "5px",
            width: "20px",
            height: "20px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          className={`pagination_clickable${process.env.REACT_APP_TYPE}`}
          onClick={() => {
            if (props.pageNumber > 1)
              props.handlePagination(props.pageNumber - 1);
          }}
        >
          <KeyboardArrowLeftIcon style={{ color: "grey", fontSize: "20px" }} />
        </div>
        <div
          style={{
            border: "1px solid #dddddd",
            padding: "5px 10px",
            width: "auto",
            height: "20px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            color: "gray",
            cursor: "pointer",
          }}
        >
          <input
            type="number"
            placeholder="Page"
            value={props.pageNumber}
            onChange={(e) => {
              props.handlePagination(e.target.value);
            }}
            style={{
              border: "none",
              background: "unset",
              width: "100%",
              textAlign: "center",
              maxWidth: "40px",
              fontSize: "16px",
              borderBottom: "1px solid gray",
            }}
          />
          / {props.paginatedProperties.last_page}
        </div>
        <div
          style={{
            border: "1px solid #dddddd",
            padding: "5px",
            width: "20px",
            height: "20px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          className={`pagination_clickable${process.env.REACT_APP_TYPE}`}
          onClick={() => {
            if (props.pageNumber < props.paginatedProperties.last_page)
              props.handlePagination(Number(props.pageNumber) + Number(1));
          }}
        >
          <KeyboardArrowRightIcon style={{ color: "grey", fontSize: "20px" }} />
        </div>
        <div
          style={{
            border: "1px solid #dddddd",
            padding: "5px",
            width: "20px",
            height: "20px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          className={`pagination_clickable${process.env.REACT_APP_TYPE}`}
          onClick={() => {
            props.handlePagination(props.paginatedProperties.last_page);
          }}
        >
          <LastPageIcon style={{ color: "grey", fontSize: "20px" }} />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
